import React from "react";
import { useNavigate } from "react-router-dom";

import { authStore } from "@/store/auth";

import api from "@/api/index";

import { LeftCircleOutlined } from "@ant-design/icons";
import { HomeOutlined } from "@ant-design/icons"

import HeaderUser from './HeaderUser'

import "./styles/app-header.scss";

interface Props {
  title: string;
  link?: string;
  back?: () => void;
  isLogout?: boolean;
}

function AppHeader({ title, link, back, isLogout }: Props) {
  const navigate = useNavigate();

  const onBack = () => {
    if (link) {
      navigate(link);
      return;
    }

    if (onBack) {
      onBack();
    }
  };

  const onLogout = () => {
    authStore.logout();
    navigate("/login");

    api.auth.logout()
  };

  return (
    <header className="app-header">
      <div className={"app-container"}>
        <div className="app-header__container">
          <div className="app-header__left">
            <a href='/' className="app-header__home"><HomeOutlined /></a>

            {link && (
              <div className="app-header__control">
                <a className="app-link-icon app-header__back" onClick={onBack}>
                  <LeftCircleOutlined />
                </a>
              </div>
            )}
            <h3 className="app-header__title desktop">{title}</h3>
          </div>

          <div className={"app-header__controls"}>
            <HeaderUser />

            {/*{*/}
            {/*  <a className={"app-header__logout"} onClick={onLogout}>*/}
            {/*    <span className={'app-header__logout__desktop'}>Выйти</span>*/}
            {/*    <span className={'app-header__logout__mobile'}>Выйти</span>*/}
            {/*  </a>*/}
            {/*}*/}
          </div>
        </div>
      </div>
    </header>
  );
}

export default AppHeader;
